import React, { useState, useRef, useEffect } from "react";
import tinymce from "tinymce/tinymce"; // core
import "tinymce/themes/silver/theme"; // theme
import "tinymce/icons/default"; // icons

// Simple unique ID generator safe for CSS selectors
let editorCounter = 0;
function generateEditorId() {
  editorCounter += 1;
  return `tinymce-editor-${editorCounter}`;
}

export default function TinyMCEEditor({
    value,
    onChange,
    height = 400,
    initialHtml = "<p>Initial content</p>",
  }) {
  const editorRef = useRef(null);
  const [editorId] = useState(generateEditorId);
  const [isEditorReady, setIsEditorReady] = useState(false);

  // Initialize TinyMCE editor
  useEffect(() => {
    tinymce.init({
      selector: `#${editorId}`,
      height,
      menubar: true,
      plugins: [
        "advlist", "autolink", "lists", "link", "image", "charmap",
        "preview", "anchor", "searchreplace", "visualblocks", "code",
        "fullscreen", "insertdatetime", "media", "table", "help",
      ],
      toolbar:
        "undo redo | formatselect | bold italic backcolor | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | removeformat | image | code | help",
      setup: (editor) => {
        editorRef.current = editor;
        editor.on("Change KeyUp", () => {
          const newContent = editor.getContent();
          if (onChange) onChange(newContent);
        });
        editor.on("init", () => {
          setIsEditorReady(true);
          // Set initial content
          const initialContent = value || initialHtml;
          editor.setContent(initialContent);
        });
      },
      base_url: "/tinymce", // your self-hosted TinyMCE path
      suffix: ".min",
    });

    return () => {
      if (editorRef.current) {
        tinymce.remove(editorRef.current);
      }
    };
  }, []);

  // Update editor content when value prop changes
  useEffect(() => {
    if (isEditorReady && editorRef.current && value !== undefined) {
      const currentContent = editorRef.current.getContent();
      if (currentContent !== value) {
        editorRef.current.setContent(value || "");
      }
    }
  }, [value, isEditorReady]);

  return (
    <div style={{ margin: "20px auto" }}>
      <textarea id={editorId}></textarea>
    </div>
  );
}
